export default __webpack_public_path__ + "static/media/banner.6344aadf.mp4";